"use client";
import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "../utils";

export interface LabelProps extends React.ComponentProps<typeof LabelPrimitive.Root> {
  /**
   * Renders the required-field marker (*) after the label text. Purely visual
   * (aria-hidden) — pair it with `required` / `aria-required` on the control.
   */
  required?: boolean;
}
function Label({ className, required, children, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
      {required && (
        // quovy-lint-ignore prefer-notice -- required-field marker, not a message
        <span aria-hidden className="-ml-1 text-destructive">
          *
        </span>
      )}
    </LabelPrimitive.Root>
  );
}
export { Label };
